import { useContext } from "react";
import { Box, CircularProgress, Grid } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { InnerWrapper, MainContainer, TitleAndActionBox, FilterNonIdeal } from "../../../../common";
import { AppPagination, UBButton } from "../../../../../Libraries";
import useBillingConsumerBills from "../../../../../hooks/useBillingConsumerBills";
import BillRow from "./BillRow";
import { analytics, triggerLogEvent } from "../../../../../config/firebase";
import styles from "./ConsumerBillsListing.module.css";
import walletMainStyles from "../../WalletMain.module.css";
import { sentenceCase } from "../../../../../constants";
import { LanguageContext } from "../../../../../context/LanguageContext";

const ConsumerBillsListing = () => {
  const [I18n] = useContext(LanguageContext);
  const { state } = useLocation();
  const navigate = useNavigate();

  const customerPhone = state?.customerPhone || null;
  const customerName = sentenceCase(state?.customerName) || null;
  const consumerNumber = state?.consumerNumber || null;
  const companyName = state?.companyName || null;
  const billingCompany = state?.billingCompany || companyName;

  const { bills, hasNext, isLoading, isInitialLoading, handleLoadMore } = useBillingConsumerBills({
    customerPhone,
    consumerNumber,
  });

  const title = [customerName, companyName].filter(Boolean).join(" - ") || I18n.bills;

  const handlePayBill = (bill) => {
    navigate("/UCash/BillPayments", {
      state: {
        billingCompany,
        consumerNumber: bill?.consumer_number || consumerNumber,
        consumerName: bill?.consumer_name || null,
        prefilledCustomerName: customerName,
      },
    });
  };

  const handleRowClick = (bill) => {
    const transactionId = bill?.transaction_details?.id;
    if (transactionId) {
      navigate(`/UCash/TransactionDetail/bill_payment/${transactionId}`);
    }
  };

  return (
    <MainContainer fluid className="quickSalePage">
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              title,
              isBack: true,
              onBack: () => navigate(-1),
              id: "consumer_bills",
              isTitleCase : false
              
            }}
          >
            <UBButton
              id="consumer_bills_pay_bill_btn"
              title={I18n.pay_bill}
              className="ubButtonStyle ubPrimaryButton textUppercase fontSize14"
              onClick={() => {
                triggerLogEvent(analytics, "w_bill_txn_consumer_pay_bill");
                navigate("/UCash/BillPayments", {
                  state: { billingCompany, consumerNumber, consumerName: null, prefilledCustomerName: customerName },
                });
              }}
            />
          </TitleAndActionBox>

          <InnerWrapper className="innerWrapper newInnerWrapper">
            <Box className="invoiceListTableHeader accountTableHeaderMain">
              <Box className="invListTableHeaderCol fiveColumn textLeft">
                <span className="fontSize12 fontWeight500 newLightColor">{I18n.month}</span>
              </Box>
              <Box className="invListTableHeaderCol fiveColumn textLeft">
                <span className="fontSize12 fontWeight500 newLightColor">{I18n.consumer_id}</span>
              </Box>
              <Box className="invListTableHeaderCol fiveColumn textLeft">
                <span className="fontSize12 fontWeight500 newLightColor">{I18n.due_date}</span>
              </Box>
              <Box className="invListTableHeaderCol fiveColumn textRight">
                <span className="fontSize12 fontWeight500 newLightColor">{I18n.amount}</span>
              </Box>
              <Box className="invListTableHeaderCol fiveColumn justifyEnd">
                <span className="fontSize12 fontWeight500 newLightColor">{I18n.actions}</span>
              </Box>
            </Box>

            <Box className={`${styles.listWrapper} generic-scrollbar`} id="billsScrollable">
              {isInitialLoading ? (
                <Box className={`${walletMainStyles.transactionListLoadingBox} h-100`}>
                  <CircularProgress size={25} />
                </Box>
              ) : bills.length === 0 ? (
                <Box className="h-100">
                  <FilterNonIdeal
                    title={I18n.no_bills_found}
                    subTitle={I18n.bills_will_appear_here_once_available}
                  />
                </Box>
              ) : (
                <AppPagination
                  data={{
                    handleNext: handleLoadMore,
                    pageLoad: isLoading,
                    count: hasNext,
                    list: bills,
                    scrollableTarget: "billsScrollable",
                  }}
                >
                  {bills.map((item, idx) => (
                    <BillRow
                      key={item.id || idx}
                      item={item}
                      onPayBill={handlePayBill}
                      onRowClick={handleRowClick}
                    />
                  ))}
                </AppPagination>
              )}
            </Box>
          </InnerWrapper>
        </Grid>
      </Grid>
    </MainContainer>
  );
};

export default ConsumerBillsListing;
